// import React, { useEffect, useState } from "react";
// import axios from "axios";

// const Settings = () => {
//   const [formData, setFormData] = useState({
//     siteName: "",
//     adminEmail: "",
//     razorpayUserId: "",
//     razorpayToken: "",
//     smsKey: "",
//   });

//   // GET API - Load Existing Data
//   const fetchSettings = async () => {
//     try {
//       const res = await axios.get(
//         `api/v1/admin/site-settings/view-site-settings`
//       );

//       if (res.data.success && res.data.data) {
//         setFormData({
//           siteName: res.data.data.siteName || "",
//           adminEmail: res.data.data.adminEmail || "",
//           razorpayUserId: res.data.data.razorpayUserId || "",
//           razorpayToken: res.data.data.razorpayToken || "",
//           smsKey: res.data.data.smsKey || "",
//         });
//       }
//     } catch (error) {
//       console.error("Error fetching settings:", error);
//     }
//   };

//   // Update local state when typing
//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   // POST API - Save Data
//   const saveSettings = async () => {
//     try {
//       const res = await axios.post(
//         `api/v1/admin/site-settings/add-or-update-site-settings`,
//         formData
//       );

//       if (res.data.success) {
//         alert("Settings updated successfully!");
//       }
//     } catch (error) {
//       console.error("Error saving settings:", error);
//     }
//   };

//   useEffect(() => {
//     fetchSettings();
//   }, []);

//   return (
//     <div className="p-6 bg-white min-h-screen text-[var(--black-text)]">
//       <h1 className="text-2xl font-bold mb-4 text-[var(--primary-solid)]">Settings</h1>

//       <div className="bg-white border-2 border-gray-200 rounded-lg p-6 shadow-sm">
//         <div className="space-y-5">

//           {/* Agora App Id */}
//           <div>
//             <label className="block text-sm font-medium text-[var(--black-text)] mb-2">
//               Agora App ID
//             </label>
//             <input
//               type="text"
//               name="siteName"
//               value={formData.siteName}
//               onChange={handleChange}
//               className="w-full px-3 py-2 rounded-lg 
//               bg-white text-[var(--black-text)] 
//               border-2 border-gray-200 
//               focus:outline-none focus:ring-2 focus:ring-[var(--primary-solid)]/50 focus:border-[var(--primary-solid)]"
//             />
//           </div>
//           {/* Agora App Certificate */}
//           <div>
//             <label className="block text-sm font-medium text-[var(--black-text)] mb-2">
//               Agora App Certificate
//             </label>
//             <input
//               type="text"
//               name="siteName"
//               value={formData.siteName}
//               onChange={handleChange}
//               className="w-full px-3 py-2 rounded-lg 
//               bg-white text-[var(--black-text)] 
//               border-2 border-gray-200 
//               focus:outline-none focus:ring-2 focus:ring-[var(--primary-solid)]/50 focus:border-[var(--primary-solid)]"
//             />
//           </div>

          
//           {/* Payment Gateway Key ID */}
//           <div>
//             <label className="block text-sm font-medium text-[var(--black-text)] mb-2">
//               Payment Gateway Key ID
//             </label>
//             <input
//               type="text"
//               name="razorpayUserId"
//               value={formData.razorpayUserId}
//               onChange={handleChange}
//               className="w-full px-3 py-2 rounded-lg 
//               bg-white text-[var(--black-text)]
//               border-2 border-gray-200
//               focus:outline-none focus:ring-2 focus:ring-[var(--primary-solid)]/50 focus:border-[var(--primary-solid)]"
//             />
//           </div>

//           {/* Payment Gateway Secret Key ID */}
//           <div>
//             <label className="block text-sm font-medium text-[var(--black-text)] mb-2">
//               Payment Gateway Secret ID
//             </label>
//             <input
//               type="text"
//               name="razorpayUserId"
//               value={formData.razorpayUserId}
//               onChange={handleChange}
//               className="w-full px-3 py-2 rounded-lg 
//               bg-white text-[var(--black-text)]
//               border-2 border-gray-200
//               focus:outline-none focus:ring-2 focus:ring-[var(--primary-solid)]/50 focus:border-[var(--primary-solid)]"
//             />
//           </div>

//           {/* Razorpay User ID */}
//           <div>
//             <label className="block text-sm font-medium text-[var(--black-text)] mb-2">
//               Razorpay UserId
//             </label>
//             <input
//               type="text"
//               name="razorpayUserId"
//               value={formData.razorpayUserId}
//               onChange={handleChange}
//               className="w-full px-3 py-2 rounded-lg 
//               bg-white text-[var(--black-text)]
//               border-2 border-gray-200
//               focus:outline-none focus:ring-2 focus:ring-[var(--primary-solid)]/50 focus:border-[var(--primary-solid)]"
//             />
//           </div>

//           {/* Razorpay Token */}
//           <div>
//             <label className="block text-sm font-medium text-[var(--black-text)] mb-2">
//               Razorpay Token
//             </label>
//             <input
//               type="text"
//               name="razorpayToken"
//               value={formData.razorpayToken}
//               onChange={handleChange}
//               className="w-full px-3 py-2 rounded-lg 
//               bg-white text-[var(--black-text)]
//               border-2 border-gray-200
//               focus:outline-none focus:ring-2 focus:ring-[var(--primary-solid)]/50 focus:border-[var(--primary-solid)]"
//             />
//           </div>

//           {/* SMS Key */}
//           <div>
//             <label className="block text-sm font-medium text-[var(--black-text)] mb-2">
//               SMS Key
//             </label>
//             <input
//               type="text"
//               name="smsKey"
//               value={formData.smsKey}
//               onChange={handleChange}
//               className="w-full px-3 py-2 rounded-lg 
//               bg-white text-[var(--black-text)]
//               border-2 border-gray-200
//               focus:outline-none focus:ring-2 focus:ring-[var(--primary-solid)]/50 focus:border-[var(--primary-solid)]"
//             />
//           </div>

//           {/* Save Settings */}
//           <button
//             onClick={saveSettings}
//             className="px-6 py-3 
//             bg-[var(--yellow)] text-[var(--black)]
//             rounded-lg font-semibold 
//             hover:opacity-90 w-full"
//           >
//             Save Settings
//           </button>

//         </div>
//       </div>
//     </div>
//   );
// };

// export default Settings;




















































import React, { useEffect, useState } from "react";
import axios from "axios";

const Settings = () => {
  const [formData, setFormData] = useState({
    siteName: "",
    contactEmail: "",

    privacyPolicyUrl: "",
    termsUrl: "",
    communityGuidelinesUrl: "",
    coinPolicyUrl: "",
    aboutUsUrl: "",

    agoraAppId: "",
    agoraAppCertificate: "",

    cloudinaryCloudName: "",
    cloudinaryApiKey: "",
    cloudinaryApiSecret: "",

    razorpayKeyId: "",
    razorpayKeySecret: "",

    smsApiKey: "",
  });

  const inputStyle =
    "w-full px-3 py-2 rounded-lg border-2 border-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-400";

  // ✅ Fetch settings
  const fetchSettings = async () => {
    try {
      const res = await axios.get("/api/v1/admin/site-settings/view-site-settings");

      if (res.data.success && res.data.data) {
        // setFormData({ ...formData, ...res.data.data });
       
        setFormData(prev => ({
  ...prev,
  ...res.data.data
}));

      }
    } catch (err) {
      console.error("Fetch error:", err);
    }
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  // ✅ Handle change
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  // ✅ Save settings
  const saveSettings = async () => {
    try {
      const res = await axios.post(
        "/api/v1/admin/site-settings/add-or-update-site-settings",
        formData
      );

      if (res.data.success) {
        alert("Settings saved successfully!");
      }
    } catch (err) {
      console.error("Save error:", err);
    }
  };

  return (
    <div className="p-6 bg-white min-h-screen">
      <h1 className="text-2xl font-bold mb-6">Site Settings</h1>

      <div className="space-y-6">

        {/* GENERAL */}
        <Section title="General">
          

          <Field label="Contact Email">
            <input name="contactEmail" value={formData.contactEmail}
              onChange={handleChange} className={inputStyle} />
          </Field>
        </Section>

        {/* LINKS */}
        <Section title="Policy Links">
          <Field label="Privacy Policy URL">
            <input name="privacyPolicyUrl" value={formData.privacyPolicyUrl}
              onChange={handleChange} className={inputStyle} />
          </Field>

          <Field label="Terms & Conditions URL">
            <input name="termsUrl" value={formData.termsUrl}
              onChange={handleChange} className={inputStyle} />
          </Field>

          <Field label="Community Guidelines URL">
            <input name="communityGuidelinesUrl"
              value={formData.communityGuidelinesUrl}
              onChange={handleChange} className={inputStyle} />
          </Field>

          <Field label="Coin Policy URL">
            <input name="coinPolicyUrl" value={formData.coinPolicyUrl}
              onChange={handleChange} className={inputStyle} />
          </Field>

          <Field label="About Us URL">
            <input name="aboutUsUrl" value={formData.aboutUsUrl}
              onChange={handleChange} className={inputStyle} />
          </Field>
        </Section>

        {/* AGORA */}
        <Section title="Agora Config">
          <Field label="Agora App ID">
            <input name="agoraAppId" value={formData.agoraAppId}
              onChange={handleChange} className={inputStyle} />
          </Field>

          <Field label="Agora Certificate">
            <input name="agoraAppCertificate"
              value={formData.agoraAppCertificate}
              onChange={handleChange} className={inputStyle} />
          </Field>
        </Section>

        {/* CLOUDINARY */}
        <Section title="Cloudinary">
          <Field label="Cloud Name">
            <input name="cloudinaryCloudName"
              value={formData.cloudinaryCloudName}
              onChange={handleChange} className={inputStyle} />
          </Field>

          <Field label="API Key">
            <input name="cloudinaryApiKey"
              value={formData.cloudinaryApiKey}
              onChange={handleChange} className={inputStyle} />
          </Field>

          <Field label="API Secret">
            <input  name="cloudinaryApiSecret"
              value={formData.cloudinaryApiSecret}
              onChange={handleChange} className={inputStyle} />
          </Field>
        </Section>

        {/* RAZORPAY */}
        <Section title="Razorpay">
          <Field label="Key ID">
            <input name="razorpayKeyId"
              value={formData.razorpayKeyId}
              onChange={handleChange} className={inputStyle} />
          </Field>

          <Field label="Key Secret">
            <input type="password" name="razorpayKeySecret"
              value={formData.razorpayKeySecret}
              onChange={handleChange} className={inputStyle} />
          </Field>
        </Section>

        {/* SMS */}
        <Section title="SMS">
          <Field label="SMS API Key">
            <input name="smsApiKey"
              value={formData.smsApiKey}
              onChange={handleChange} className={inputStyle} />
          </Field>
        </Section>

        <button
          onClick={saveSettings}
          className="bg-pink-700 px-6 py-3 rounded-lg font-semibold w-full"
        >
          Save Settings
        </button>

      </div>
    </div>
  );
};

// ✅ Reusable Components
const Section = ({ title, children }) => (
  <div className="border p-4 rounded-lg space-y-4">
    <h2 className="font-semibold text-lg">{title}</h2>
    {children}
  </div>
);

const Field = ({ label, children }) => (
  <div>
    <label className="block text-sm font-medium mb-1">{label}</label>
    {children}
  </div>
);

export default Settings;
